import React from 'react'

export default function VisiGiftPointsHistory() {
  return (
    <div>VisiGiftPointsHistory</div>
  )
}
